import groq from 'groq';

import { CLOUDINARY_VIDEO, RICH_TEXT, STUDY_MODAL } from '../common';

/* TODO: We can remove the coalesce once the field name migration is done in the CMS. See:
 * https://app.asana.com/1/1207316259538846/project/1211530870097835/task/1217359678245160 */
export const MITOCHONDRIAL_DECLINE = groq`
  _type,
  title,
  description[] {
    ${RICH_TEXT}
  },
  "modal": coalesce(modal, benefitModal) -> { ${STUDY_MODAL} },
  bulletPoints,
  video { ${CLOUDINARY_VIDEO} },
`;

export const MITOCHONDRIAL_DECLINE_BLOCK = groq`
  _type == 'mitochondrialDecline' => @-> {
    ${MITOCHONDRIAL_DECLINE}
  }
`;
